import React, { useState } from "react";
import { Row, Col, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const ActionCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  cursor: pointer;

  &:hover .action_label,
  &:hover .action_icon {
    color: ${(props) => props.color};
  }
`;

const PriceCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  justify-content: center;
`;

const ActionLabel = styled.div`
  font-size: 12px;
  color: #6c757d;
`;

const ActionIcon = styled(FontAwesomeIcon)`
  font-size: ${(props) => props.size || "20px"};
  color: #6c757d;
  align-self: center;
`;

const Price = styled.span`
  font-size: 25px;
  color: #d9534f;

  @media (min-width: 992px) and (max-width: 1199px) {
    font-size: 20px;
  }
`;

const PriceOf = styled.span`
  font-size: 16px;
  color: #d9534f;
  text-decoration: line-through;
  margin-top: -10px;
  margin-bottom: -5px;

  @media (min-width: 992px) and (max-width: 1199px) {
    font-size: 20px;
  }
`;

const Name = styled.h3`
  font-size: 20px;
  margin: 0 0 0 0;
`;

const Desc = styled.p`
  font-size: 12px;
  margin: 0 0 0 0;
  line-height: 1;
`;

const ItemContainer = styled(Row)`
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px; // Altura da sua borda
    background: ${(props) => (props.showEndLine ? "linear-gradient(to right, #fff, #dee2e6, #fff)" : "none")};
  }
`;

const InfoIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  font-size: 0.8em;
  color: #0d6efd;
  margin-bottom: 2px;
`;

const Product = (props) => {
  const [show, setShow] = useState(false);

  const {
    name,
    desc,
    actionHoverColor,
    actionText,
    actionIcon,
    actionIconSize = "20px",
    actionOnClick,
    price,
    fullPrice,
    showEndLine = true,
    hasInfo = false,
    info = '',
  } = props;

  const [units, cents] = price.toFixed(2).split(".");
  const formattedCents = cents.padStart(2, "0");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop
        keyboard
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faCircleInfo} className="me-2" style={{ color: "#0d6efd" }} />
            {name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body dangerouslySetInnerHTML={{ __html: info }} />
      </Modal>

      <ItemContainer className="mb-3" showEndLine={showEndLine}>
        <Col lg={4} md={3} sm={3} xs={3} className="text-center center">        
          <PriceCol>
            {!isNaN(fullPrice) && (
              <PriceOf>
                  {fullPrice.toFixed(2).replace(".", ",")}
              </PriceOf>
            )}
            <Price>
              <strong>
                {units}
                <sup>,{formattedCents}</sup>
              </strong>
            </Price>
          </PriceCol>
        </Col>

        <Col lg={6} md={7} sm={7} xs={7}>
          <Name>
            {name}
            {hasInfo === 'S' && (
              <span>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-top`}>Informações adicionais</Tooltip>}
                >
                  <InfoIcon
                    icon={faCircleInfo}
                    className="ms-2"
                    onClick={handleShow}
                  />
                </OverlayTrigger>
              </span>
            )}
          </Name>
          <Desc>{desc}</Desc>
        </Col>

        <Col lg={2} md={2} sm={2} xs={2}>
          <ActionCol onClick={actionOnClick} color={actionHoverColor}>
            <div>
              <ActionIcon className="action_icon" icon={actionIcon} size={actionIconSize} />
            </div>
            <ActionLabel className="action_label">{actionText}</ActionLabel>
          </ActionCol>
        </Col>
      </ItemContainer>
    </>
  );
};

export default Product;
